export default "__VITE_ASSET__LaGGRDI0__"